<template>
  <div>
    <h3>This is the Contact page.</h3>
  </div>
</template>

<script>
export default {
  name: 'contact',
};
</script>
